var KeldaWorkerEvent;
(function (KeldaWorkerEvent) {
    KeldaWorkerEvent["START"] = "$$_KELDA_START";
    KeldaWorkerEvent["DONE"] = "$$_KELDA_DONE";
    KeldaWorkerEvent["ERROR"] = "$$_KELDA_ERROR";
})(KeldaWorkerEvent || (KeldaWorkerEvent = {}));
var WorkerJob = /** @class */ (function () {
    function WorkerJob(workModule) {
        this.isDone = false;
        this.worker = null;
        this.args = [];
        /*
          Note that Worker creation does *not* happen in the constructor.
          A new Worker is only created when .execute() is called.
          This allows Kelda to queue work efficiently by keeping as many
          Worker threads as possible available at any given time.
        */
        this.cleanUp = this.cleanUp.bind(this);
        this.workModule = workModule;
    }
    WorkerJob.prototype.with = function (args) {
        this.args = args;
        return this;
    };
    WorkerJob.prototype.execute = function () {
        this.url = this.getWorkerUrl();
        return this.getWorkPromise().finally(this.cleanUp);
    };
    WorkerJob.prototype.cleanUp = function () {
        var _a;
        this.url && URL.revokeObjectURL(this.url);
        (_a = this.worker) === null || _a === void 0 ? void 0 : _a.terminate();
        this.isDone = true;
    };
    WorkerJob.prototype.getWorkPromise = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            try {
                _this.doWorkInWorker(resolve, reject);
            }
            catch (e) {
                reject(e);
            }
        });
    };
    WorkerJob.prototype.doWorkInWorker = function (resolve, reject) {
        this.url = this.getWorkerUrl();
        this.worker = new Worker(this.url);
        this.initWorkerMessageHandling(resolve, reject);
        this.startWork();
    };
    WorkerJob.prototype.startWork = function () {
        var _a;
        (_a = this.worker) === null || _a === void 0 ? void 0 : _a.postMessage({ type: KeldaWorkerEvent.START, args: this.args });
    };
    WorkerJob.prototype.initWorkerMessageHandling = function (resolve, reject) {
        var _a;
        (_a = this.worker) === null || _a === void 0 ? void 0 : _a.addEventListener('message', function (e) {
            var _a = e.data, type = _a.type, result = _a.result, error = _a.error;
            switch (type) {
                case KeldaWorkerEvent.DONE: {
                    resolve(result);
                    break;
                }
                case KeldaWorkerEvent.ERROR: {
                    reject(error);
                    break;
                }
            }
        });
    };
    WorkerJob.prototype.getWorkerUrl = function () {
        var script = this.getWorkerScript();
        var blob = new Blob([script], { type: 'text/javascript' });
        var url = URL.createObjectURL(blob);
        return url;
    };
    WorkerJob.prototype.getWorkerScript = function () {
        // TODO: Test new version of this method
        // TODO: isDone flow is not yet tested
        // TODO: Rethrow DataCloneErrors with helpful hints about allowable return types of Work?
        // TODO: Remove tsignores if possible
        // TODO: Remove eslint-disables if possible
        // TODO: Find way not to hardcode event types
        /* eslint-disable require-atomic-updates, no-restricted-globals */
        // Coverage cannot be collected from the init function as it is stringified and eval'd
        /* istanbul ignore next */
        var init = function (provider, exportName) {
            var isDone = false;
            //@ts-ignore:
            self.onmessage = function (message) {
                var _a, _b;
                if (!isDone && ((_a = message.data) === null || _a === void 0 ? void 0 : _a.type) === '$$_KELDA_START') {
                    try {
                        // TODO: use await instead of 'result instanceof Promise'
                        // This is currently an issue as await transpiles to some
                        // TS helpers that don't exist in the MockWorker eval scope
                        var module_1 = provider();
                        if (typeof module_1 !== 'object') {
                            throw new Error('Provided work script did not evaluate to a module object');
                        }
                        var work = provider()[exportName];
                        if (!work) {
                            throw new Error("Export '" + exportName + "' was not found in provided work module");
                        }
                        var args = ((_b = message.data) === null || _b === void 0 ? void 0 : _b.args) || [];
                        var result = work.apply(null, args);
                        if (result instanceof Promise) {
                            result.then(function (unwrappedResult) {
                                //@ts-ignore:
                                self.postMessage({
                                    type: '$$_KELDA_DONE',
                                    result: unwrappedResult
                                });
                            });
                        }
                        else {
                            //@ts-ignore:
                            self.postMessage({
                                type: '$$_KELDA_DONE',
                                result: result
                            });
                        }
                    }
                    catch (error) {
                        //@ts-ignore:
                        self.postMessage({
                            type: '$$_KELDA_ERROR',
                            error: error
                        });
                    }
                    finally {
                        isDone = true;
                    }
                }
            };
        };
        return "(" + init + ")(" + this.workModule + ", \"" + this.workModule.exportName + "\")";
    };
    return WorkerJob;
}());
export default WorkerJob;
